
import { Component, Vue, Watch } from "vue-property-decorator";
import { NoticeVO } from "@/views/biz/mypage/vo/mypage.vo";
import axios from "axios";

@Component
export default class Notices extends Vue {
  //탭클릭
  tab = "";
  // 공지목록
  notices: Array<NoticeVO> = [] as Array<NoticeVO>;

  //공지검색
  @Watch("tab")
  searchNotice() {
    axios.get("/notices", { params: { noticeType: this.tab } }).then((r) => {
      this.notices = r.data;
    });
  }

  created(): void {
    this.searchNotice();
  }
}
